module.exports = __webpack_public_path__ + "img/q5-1-2@2x.746710eb.png";